module.exports = __webpack_public_path__ + "img/Banco-Santander-Peru.7a9faf38.svg";